import React from 'react';

export function FullBanner() {
  return (
    <div className="mb-6 rounded-lg bg-yellow-900/20 border border-yellow-800/50 p-4 text-yellow-200">
      <p className="font-semibold">This squad is full.</p>
    </div>
  );
}
